import { toast } from '@hivebrite/design-system/Toast';

import copyToClipboard from 'hb-react/shared/utils/copyToClipboard';

const pushCopyLinkAction = (copyLinkActionItem, items) => {
  if (copyLinkActionItem) {
    items.push(copyLinkActionItem);
  }
};
export const getActionItems = ({
  currentUser,
  handleDeleteItem,
  handleEditItem,
  handleHideUser,
  handleReportContent,
  handleToggleTopPosts,
  icons,
  isAdmin,
  item,
  itemUrl: itemDedicatedUrl,
  networkConfig,
  user,
}) => {
  const topPostsPolicies = getTopPostsPolicies({
    isAdmin,
    type: item.type,
  });

  const copyLinkActionItem = itemDedicatedUrl
    ? {
        label: __('Copy link'),
        icon: icons.copyLink,
        onClick: () => {
          copyToClipboard(itemDedicatedUrl, () => {
            toast.success(__('Link copied to clipboard'));
          });
        },
      }
    : null;

  const topPostsToggle = (items) =>
    topPostsItem(item, topPostsPolicies, handleToggleTopPosts, icons) &&
    items.push(
      topPostsItem(item, topPostsPolicies, handleToggleTopPosts, icons),
    );

  // If currentUser if the owner
  if (user?.id === currentUser?.id) {
    const items = [];

    pushCopyLinkAction(copyLinkActionItem, items);

    items.push(
      {
        label: __('Edit'),
        icon: icons.edit,
        onClick: handleEditItem,
      },
      {
        label: __('Delete'),
        icon: icons.delete,
        onClick: handleDeleteItem,
      },
    );

    // If user is admin and flag-cd-top-posts is true
    topPostsToggle(items);

    return items;
  }

  // If content from another user
  if (user) {
    const items = [];

    pushCopyLinkAction(copyLinkActionItem, items);

    if (networkConfig?.user_can_report_user_contents) {
      items.push({
        label: __('Report this content'),
        icon: icons.circleExclamation,
        onClick: handleReportContent,
        dataTestId: 'livefeed-item-report',
      });
    }

    if (currentUser?.test_account) {
      items.push({
        label: s__('BlockUser|Block user'),
        icon: icons.ban,
        onClick: handleHideUser,
        dataTestId: 'livefeed-item-hide',
      });
    }

    // If user is admin and flag-cd-top-posts is true
    topPostsToggle(items);

    if (items.length > 0) {
      return items;
    }
  }

  // Item from the network
  if (copyLinkActionItem) {
    return [copyLinkActionItem];
  }

  return null;
};

export const getTopPostsPolicies = ({ isAdmin, type }) =>
  // if you are coming from the future and need to remove flagCurrentSessionContext
  // then you can remove the following typeof ternary and only use isAdmin
  (typeof isAdmin === 'boolean'
    ? isAdmin // <-- keep this one
    : AlumniConnect.currentSession?.check_admin_dual_account &&
      AlumniConnect.currentSession?.network_admin) &&
  (type === 'posts_feed_post' || type === 'current' || type === 'trip');

const topPostsItem = (item, topPostsPolicies, handleToggleTopPosts, icons) =>
  topPostsPolicies
    ? item.pinned_to_top_posts
      ? {
          label: s__('TopPosts|Remove from top posts'),
          icon: icons.pin,
          onClick: handleToggleTopPosts,
        }
      : {
          label: s__('TopPosts|Add to top posts'),
          icon: icons.pinHollow,
          onClick: handleToggleTopPosts,
        }
    : null;
